import { render, staticRenderFns } from "./clients-map.vue?vue&type=template&id=be8e61e8"
import script from "./clients-map.vue?vue&type=script&lang=js"
export * from "./clients-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports